import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { apiGateway } from "../utils/config";
import { useRouter } from "next/router";
import { handleWebPageOpenEvent } from "../utils/utils";
import { Context } from "../store";
import { axiosPublic } from "../api/axiosCustom";
import { RouteName } from "../utils/route.utils";
import {
  indexWebpageSchema,
  indexWebsiteSchema,
  organizationStructureData,
} from "../schemas";
import styles from "../styles/v3.module.scss";
import Header from "../components/v3/components/Header";
import ScrollingCards from "../components/v3/components/ScrollingCards";
import CompanyStats from "../components/v3/components/CompanyStats";
import WatchMobile from "../components/v3/components/WatchMobile";
import Premium from "../components/v3/components/Premimum";
import CreatorComponent from "../components/v3/components/CreatorComponent";
import ReviewsComponent from "../components/v3/components/ReviewsComponent/ReviewsComponent";
import HeroSection from "../components/v3/components/HeroSection";
import useUserInformation from "../hooks/useUserInformation";
import Head from "next/head";
import TAGS from "../public/headJson.json";
import FaqAccordion from "../components/v3/components/Common/FaqAccordion";
import Footer from "../components/v3/components/Common/Footer";

export default function V3(props) {
  const { user, webviewEvent, landingPageData, setUser } = props;
  const [scrollVal, setScrollVal] = useState(0);
  // const [landingPageData, setLandingPageData] = useState({});
  const [windowSize, setWindowSize] = useState([]);
  const router = useRouter();
  const globalState = useContext(Context);
  const firebase_uid = globalState?.user?.uid || user?.uid;
  const startPrice = landingPageData?.plan?.discounted_price;
  const categoryList = landingPageData?.hero?.category_series_list;
  const future_ready = landingPageData?.future_ready;
  const faqData = landingPageData?.faqs;
  useUserInformation({});

  const structDataCarousel = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    itemListElement: categoryList.map((category, index) => {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: category?.title,
        url: `https://seekho.in/category/${category?.category_slug}`,
      };
    }),
  };

  const structDataFaq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData?.map((faq) => {
      return {
        "@type": "Question",
        name: faq?.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq?.answer,
        },
      };
    }),
  };

  const scrollCards = () => {
    const direction = window.oldScroll > window.scrollY ? 1 : -1;
    window.oldScroll = window.scrollY;
    if (scrollVal >= 0 && scrollVal < 30) {
      setScrollVal((prev) => prev + direction);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.onscroll = scrollCards;
  }, []);

  useEffect(() => {
    handleWebPageOpenEvent({
      type: "landing_page",
      webviewEvent,
      firebase_uid,
      campaignDetails: router?.query,
      client_ip: landingPageData?.client_ip,
      web_first_month_discount: `${startPrice} ${
        landingPageData?.hero_with_thumbnails ? "Play Store Home" : "Default"
      }`,
    });
  }, [firebase_uid, startPrice]);

  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.landingPage.title}</title>
        <meta name="title" content={TAGS.landingPage.title} />
        <meta name="description" content={TAGS.landingPage.description} />
        <link rel="canonical" href={RouteName.index} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.index} />
        <meta property="og:title" content={TAGS.landingPage.title} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />
        <meta
          property="og:description"
          content={TAGS.landingPage.description}
        />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.index} />
        <meta property="twitter:title" content={TAGS.landingPage.title} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />
        <meta
          property="twitter:description"
          content={TAGS.landingPage.description}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(indexWebsiteSchema),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(organizationStructureData),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(indexWebpageSchema),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structDataCarousel),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structDataFaq) }}
        />
      </Head>

      <div className={styles.v3}>
        <div className={styles.header}>
          <Header type="landing" />
        </div>

        <div>
          <div>
            <HeroSection
              heroSectionData={landingPageData?.hero}
              future_ready={future_ready}
            />
          </div>

          <div>
            {/* <MobileCategories categoryList={categoryList} /> */}
            {startPrice !== undefined && (
              <div className={styles.mobile_premium}>
                <Premium startPrice={startPrice} />
              </div>
            )}

            <div className="w-[90%] mx-auto pt-10 lg:hidden">
              <div className={styles.reviews_section}>
                <ReviewsComponent windowSize={windowSize} />
              </div>
            </div>

            {/* <div className={styles.future_ready_section_mobile}>
              <ScrollingCards
                title={future_ready?.title}
                series_list={future_ready?.series_list}
                windowSize={windowSize}
              />
            </div> */}
          </div>

          {/* For desktop only */}
          <div className="hidden lg:block">
            <div className={styles.company_stats}>
              <CompanyStats />
            </div>
          </div>

          <div className={styles.watch_mobile_Ui}>
            <WatchMobile windowSize={windowSize} />
          </div>

          {startPrice !== undefined && (
            <div className={styles.desktop_premium}>
              <Premium startPrice={startPrice} />
            </div>
          )}

          <div className={styles.future_ready_section_desktop}>
            <ScrollingCards
              title={landingPageData?.future_ready?.title}
              series_list={landingPageData?.future_ready?.series_list}
              // isLoading={isLoading}
              windowSize={windowSize}
            />
          </div>

          <div className="border-b border-gray-600">
            <CreatorComponent windowSize={windowSize} />
          </div>

          {/* Desktop reviews */}
          <div className="hidden lg:block lg:mt-[50px]">
            <div className={styles.reviews_section}>
              <ReviewsComponent windowSize={windowSize} />
            </div>
          </div>

          {/* <div className="pb-5">
            <JoinSeekhoBanner />
          </div> */}

          {faqData?.length > 0 && (
            <div className="mt-10 lg:mt-5 pb-20">
              <h2 className="text-center text-[32px] !w-[90%] mx-auto">
                Frequently Asked Questions
              </h2>
              <div className="w-[90%] mx-auto lg:w-[60%] !mt-1 lg:!mt-6">
                <FaqAccordion faq={faqData?.slice(0, 4)} />
              </div>
            </div>
          )}

          <div>
            <Footer isBottomPadding />
          </div>
        </div>
      </div>
    </>
  );
}

export const getStaticProps = async () => {
  try {
    const url = `${apiGateway}/api/v1/home/website/`;
    const response = await axiosPublic.get(url);
    return {
      props: {
        landingPageData: response?.data,
      },
      revalidate: 86400, // revalidate after 1Day
    };
  } catch (error) {
    return {
      notFound: true,
      revalidate: true,
    };
  }
};
